
// dev
// export const config =  {
//     baseUrl: 'https://pbapi.dev.boo2.nl',
//     portal_url: 'https://volvo.dev.boo2.nl',
// }

//check if prod or staging
let burl = 'https://pbapi.volvotruckandtrace.no/' ; 
let purl = 'https://volvotruckandtrace.no' ; 

if( window.location.hostname.includes("volvotruckandtrace.no") ){
    burl = 'https://pbapi.volvotruckandtrace.no/' ; 
    purl = 'https://volvotruckandtrace.no' ; 
}
export const config =  {
    baseUrl: burl ,
    portal_url: purl ,
}